import { render, staticRenderFns } from "./HowWeWork.vue?vue&type=template&id=23f5c645&"
import script from "./HowWeWork.vue?vue&type=script&lang=js&"
export * from "./HowWeWork.vue?vue&type=script&lang=js&"
import style0 from "./HowWeWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports